import { config } from 'affiny-core/env';
import React from 'react';
import { FLAGS } from './featureToggleFlags';

interface IFeatureToggle {
  flag: FLAGS;
  children: React.ReactNode;
}

export const FeatureToggle = ({ flag, children }: IFeatureToggle) =>
  isFeatureEnabled(flag) ? <>{children}</> : null;

export const isFeatureEnabled = (flag: FLAGS) =>
  config.env.featureToggling[flag];
